import { api } from "./api";
import { ENDPOINTS } from "./endpoints";
import { operations } from "../types/openapi";

type getRequestStatisticsOperation = operations["getRequestStatistics"];

/**
 * Отображает общий счетчик и счетчики по статусам
 * @description Отображает общий счетчик и счетчики по статусам (доступен для CUSTOMER, OPERATOR, LIQUIDITY_PROVIDER)
 */
export const getPendingStatistics = (): Promise<
  getRequestStatisticsOperation["responses"]["200"]["content"]["*/*"]
> => {
  return api.get(ENDPOINTS.pendingStatistics());
};
